import React from 'react'
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ActionsContextV2 from '../ActionsContextV2';

const Container = styled.div`

min-height:300px;
display:flex;
align-items:center;
flex-direction:column;
text-align:center;
`
const Title = styled.div`


padding-top:20px;
font-family: Roboto;
font-weight: 700;
font-size:18px;
color:#5F5F5F
padding-bottom:20px;

`
const Subtitle = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;

`

const Caption = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:14px;
color:#5F5F5F
padding-bottom:20px;

`

const ButtonContainer = styled.div`

display:flex;
align-items:center;
justify-content:center;

`

const ActionFormNoPendingEmptyState = ({readOnly}) => {


    const context = React.useContext(ActionsContextV2);

    return(
        <Container>
            <Title>
                All pending procedures are complete.
            </Title>
            <Subtitle>
                All pending procedures have been reviewed by the required approvers.<br/>
                Take a look at your procedures list to view or publish your functional procedures manual.
            </Subtitle>
            <Caption>
                (This list is always available by clicking the icon to the left of your function name.)
            </Caption>
            <ButtonContainer>
                <Button 
                    color="primary" 
                    variant="outlined"
                    onClick={()=>context.showProcedureManual({...context.actionsRedux.selectedProjectFunctionDetails,readOnly})}
                >
                    View the Procedures List
                </Button>
            </ButtonContainer>
        </Container>
    );


}


export default ActionFormNoPendingEmptyState;